// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"036bd2e0","977":"698cf111"}[chunkId] + ".chunk.js";
};